import { render, staticRenderFns } from "./DialogNameDescription.vue?vue&type=template&id=fca83b16&"
import script from "./DialogNameDescription.vue?vue&type=script&lang=js&"
export * from "./DialogNameDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fca83b16')) {
      api.createRecord('fca83b16', component.options)
    } else {
      api.reload('fca83b16', component.options)
    }
    module.hot.accept("./DialogNameDescription.vue?vue&type=template&id=fca83b16&", function () {
      api.rerender('fca83b16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/DialogNameDescription.vue"
export default component.exports